function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { extractVNodeData, cloneVNode } from '@cloud-sn/v-utils';
import { buildComponentName } from '../utils';
import Icon from '../icon';
import Item from './item';
export default {
  name: buildComponentName('Timeline'),
  provide: function provide() {
    return {
      timelineRoot: this
    };
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ux-timeline'
    },
    pending: {
      type: [Boolean, String],
      default: false
    },
    reverse: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          reverse = this.reverse;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-reverse"), reverse), _ref;
    }
  },
  methods: {
    renderChildren: function renderChildren() {
      var slotDefault = this.$slots.default,
          prefixCls = this.prefixCls,
          reverse = this.reverse;

      if (slotDefault) {
        if (reverse) {
          slotDefault.reverse();
        }

        var lastNode = slotDefault.pop();
        var vnodeData = extractVNodeData(lastNode);
        slotDefault.push(cloneVNode(lastNode, {
          class: [vnodeData.class, "".concat(prefixCls, "-item-last")]
        }));
      }

      return slotDefault;
    }
  },
  render: function render() {
    var h = arguments[0];
    var _this$$slots = this.$slots,
        slotPending = _this$$slots.pending,
        slotPendingDot = _this$$slots.pendingDot,
        prefixCls = this.prefixCls,
        pending = this.pending,
        reverse = this.reverse,
        classes = this.classes,
        renderChildren = this.renderChildren;
    var children = renderChildren();
    var hasPending = !!pending || !!slotPending;
    var pendingNode = h(Item, {
      "class": "".concat(prefixCls, "-item-pending")
    }, [h("template", {
      "slot": "dot"
    }, [slotPendingDot || h(Icon, {
      "attrs": {
        "type": "loading"
      }
    })]), slotPending || pending]);

    if (hasPending) {
      if (children) {
        children[reverse ? 'unshift' : 'push'](pendingNode);
      } else {
        children = [pendingNode];
      }
    }

    return h("ul", {
      "class": [classes, _defineProperty({}, "".concat(prefixCls, "-pending"), !!hasPending)]
    }, [children]);
  }
};